import {stringToHTML} from "../helpers";

export default () => {
  var values = document.querySelectorAll(".raw_html_code .metafield-multi_line_text_field");
  for (let i = 0; i < values.length; i++){
    var obj = values[i];
    var meta_specification = obj.innerHTML.replaceAll("&amp;",'&').replaceAll("&gt;",'>').replaceAll("&lt;",'<').replaceAll("&quot;",'/"');

    obj.innerHTML = stringToHTML(meta_specification)['innerHTML'];
    obj.classList.remove('fnd_hidden');
  }
}
